const layout = {
  state: {
    
  },
  mutations: {
    
  },
  actions: {
  }
}

export default layout


// WEBPACK FOOTER //
// ./src/store/modules/layout.js